<template>
    <RectangleTile @click="handleCardClick" class="background-tile-primary" v-interact>



        <template v-slot:badge>
            <TileBadge :name="categoryName"></TileBadge>
        </template>



        <template v-slot:icon>
            <TileIcon :padding="'8px'">
                <SafeImage :src="ofr?.icon"></SafeImage>
            </TileIcon>
        </template>



        <template v-slot:details>
            <TileDetails>
                <template v-slot:name>{{ ofr?.name }}</template>
                <template v-slot:description>{{ ofr?.instructions }}</template>
            </TileDetails>
        </template>



        <template v-slot:actions>
            <TileCoins :coins_amount="ofr?.coins_amount" :offer-platforms="ofr?.platforms" :show-boost="true">
            </TileCoins>
        </template>



    </RectangleTile>
</template>



<script setup lang="ts">

import { computed } from 'vue';
import { OfferStore } from '@/store/offerStore';
import { getCategoryName } from '@/utils/utils';
import { Offer } from '@/interfaces/Offers/Offer';

import TileIcon from "@/components/Common/Tile-Icon.vue";
import SafeImage from '@/components/Common/SafeImage.vue';
import TileBadge from '@/components/Common/Tile-Badge.vue';
import TileCoins from "@/components/Common/Tile-Coins.vue";
import TileDetails from '@/components/Common/Tile-Details.vue';
import RectangleTile from '@/components/Tiles/Rectangle-Tile.vue';

const emit = defineEmits<{
    (e: 'click'): void
}>();

const props = defineProps({
    id: String,
    offer: Object as () => Offer,
});
const offerStore = OfferStore();

const ofr = computed(() => {
    return props.offer;
});


const categoryName = computed(() => {
    if (ofr.value) {
        return getCategoryName(ofr.value.category_id);
    }
    return '';
});


const handleCardClick = () => {
    if (ofr.value) {
        offerStore.selectOffer(ofr.value);
        emit('click');
    }
}

</script>
